import type { TracingOption } from '@datadog/browser-rum-core'

/** URLs that receive distributed tracing headers (browser RUM + Vercel OTel fetch). */
export const ALLOWED_TRACING_URL_MATCHES: RegExp[] = [
  // staging
  /^https:\/\/api\.staging\.guidecx\.io/,
  /^https:\/\/k2-web\.staging\.guidecx\.io/,
  /^https:\/\/k2\.staging\.guidecx\.io/,

  // production
  /^https:\/\/api\.guidecx\.com/,
  /^https:\/\/k2-web\.guidecx\.com/,
  /^https:\/\/k2\.guidecx\.com/,
]

/** Browser RUM: Datadog + W3C so K2 otelgrpc can continue the same trace. */
export const ALLOWED_TRACING_URLS_DATADOG: TracingOption[] =
  ALLOWED_TRACING_URL_MATCHES.map((match) => ({
    match,
    propagatorTypes: ['datadog', 'tracecontext'],
  }))
